// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Tour/TourStep.module.css */
.TourStep_overlay__SZCbl {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  animation: TourStep_fadeIn__IrLiv 0.3s ease;
}

@keyframes TourStep_fadeIn__IrLiv {
  from { opacity: 0; }
  to { opacity: 1; }
}

.TourStep_tooltip__LraE8 {
  position: absolute;
  z-index: 10001;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 380px;
  max-width: calc(100vw - 40px);
  animation: TourStep_slideUp__SoPHa 0.3s ease-out;
}

@keyframes TourStep_slideUp__SoPHa {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.TourStep_arrow__Qu\\+-Q {
  position: absolute;
  width: 0;
  height: 0;
  border: 10px solid transparent;
}

.TourStep_arrowup__H8bfO {
  border-bottom-color: white;
}

.TourStep_arrowdown__1xFam {
  border-top-color: white;
}

.TourStep_arrowleft__L6nqm {
  border-right-color: white;
}

.TourStep_arrowright__GH2Lv {
  border-left-color: white;
}

.TourStep_content__hlz3C {
  padding: 28px 28px 20px;
}

.TourStep_iconWrapper__9s1TI {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: white;
}

.TourStep_title__rPlCs {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 10px 0;
  line-height: 1.3;
}

.TourStep_description__D0IFW {
  font-size: 15px;
  color: #4a5568;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.TourStep_image__3x56B {
  width: 100%;
  border-radius: 8px;
  margin-top: 12px;
  border: 1px solid #e2e8f0;
}

.TourStep_footer__kQJ5o {
  padding: 16px 28px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.TourStep_progress__nHTEE {
  display: flex;
  gap: 6px;
  align-items: center;
}

.TourStep_dot__xlVRN {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e0;
  transition: all 0.3s ease;
}

.TourStep_activeDot__oCzn3 {
  background: #667eea;
  width: 28px;
  border-radius: 10px;
}

.TourStep_completedDot__QyhL3 {
  background: #667eea;
}

.TourStep_actions__msK\\+6 {
  display: flex;
  gap: 8px;
  align-items: center;
}

.TourStep_skipBtn__84sY0 {
  padding: 8px 14px;
  border: none;
  background: transparent;
  color: #718096;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s;
}

.TourStep_skipBtn__84sY0:hover {
  background: #f7fafc;
  color: #4a5568;
}

.TourStep_prevBtn__0a73A {
  padding: 8px 18px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #4a5568;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s;
}

.TourStep_prevBtn__0a73A:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
}

.TourStep_nextBtn__6e5eL, .TourStep_finishBtn__c61i\\+ {
  padding: 8px 22px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}

.TourStep_nextBtn__6e5eL:hover, .TourStep_finishBtn__c61i\\+:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.TourStep_nextBtn__6e5eL:active, .TourStep_finishBtn__c61i\\+:active {
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/Component/Tour/TourStep.module.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,cAAc;EACd,2CAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,6BAA6B;EAC7B,gDAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* src/components/Tour/TourStep.module.css */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 10000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.tooltip {\n  position: absolute;\n  z-index: 10001;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  width: 380px;\n  max-width: calc(100vw - 40px);\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 10px solid transparent;\n}\n\n.arrowup {\n  border-bottom-color: white;\n}\n\n.arrowdown {\n  border-top-color: white;\n}\n\n.arrowleft {\n  border-right-color: white;\n}\n\n.arrowright {\n  border-left-color: white;\n}\n\n.content {\n  padding: 28px 28px 20px;\n}\n\n.iconWrapper {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  color: white;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 10px 0;\n  line-height: 1.3;\n}\n\n.description {\n  font-size: 15px;\n  color: #4a5568;\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n}\n\n.image {\n  width: 100%;\n  border-radius: 8px;\n  margin-top: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.footer {\n  padding: 16px 28px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.progress {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #cbd5e0;\n  transition: all 0.3s ease;\n}\n\n.activeDot {\n  background: #667eea;\n  width: 28px;\n  border-radius: 10px;\n}\n\n.completedDot {\n  background: #667eea;\n}\n\n.actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.skipBtn {\n  padding: 8px 14px;\n  border: none;\n  background: transparent;\n  color: #718096;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.skipBtn:hover {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.prevBtn {\n  padding: 8px 18px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  color: #4a5568;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.prevBtn:hover {\n  background: #f7fafc;\n  border-color: #cbd5e0;\n}\n\n.nextBtn, .finishBtn {\n  padding: 8px 22px;\n  border: none;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.nextBtn:hover, .finishBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n}\n\n.nextBtn:active, .finishBtn:active {\n  transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `TourStep_overlay__SZCbl`,
	"fadeIn": `TourStep_fadeIn__IrLiv`,
	"tooltip": `TourStep_tooltip__LraE8`,
	"slideUp": `TourStep_slideUp__SoPHa`,
	"arrow": `TourStep_arrow__Qu+-Q`,
	"arrowup": `TourStep_arrowup__H8bfO`,
	"arrowdown": `TourStep_arrowdown__1xFam`,
	"arrowleft": `TourStep_arrowleft__L6nqm`,
	"arrowright": `TourStep_arrowright__GH2Lv`,
	"content": `TourStep_content__hlz3C`,
	"iconWrapper": `TourStep_iconWrapper__9s1TI`,
	"title": `TourStep_title__rPlCs`,
	"description": `TourStep_description__D0IFW`,
	"image": `TourStep_image__3x56B`,
	"footer": `TourStep_footer__kQJ5o`,
	"progress": `TourStep_progress__nHTEE`,
	"dot": `TourStep_dot__xlVRN`,
	"activeDot": `TourStep_activeDot__oCzn3`,
	"completedDot": `TourStep_completedDot__QyhL3`,
	"actions": `TourStep_actions__msK+6`,
	"skipBtn": `TourStep_skipBtn__84sY0`,
	"prevBtn": `TourStep_prevBtn__0a73A`,
	"nextBtn": `TourStep_nextBtn__6e5eL`,
	"finishBtn": `TourStep_finishBtn__c61i+`
};
export default ___CSS_LOADER_EXPORT___;
